module.exports = __webpack_public_path__ + "img/order-confirmation.b40e6646.png";